import { render, staticRenderFns } from "./manage-static-groups.vue?vue&type=template&id=7c90add7&scoped=true"
import script from "./manage-static-groups.vue?vue&type=script&lang=js"
export * from "./manage-static-groups.vue?vue&type=script&lang=js"
import style0 from "./manage-static-groups.vue?vue&type=style&index=0&id=7c90add7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c90add7",
  null
  
)

export default component.exports